import { createSlice } from "@reduxjs/toolkit";
import {
  loginUser,
  // verifyEmail,
  logoutUser,
  resetPassword,
  resetPasswordLink,
  resetPasswordLinkVerification,
  generateTwoFactor,
  verifyTwoFactor,
} from "../../thunks/authenticationThunk";
import { PURGE } from "redux-persist";

interface AuthenticationState {
  loginLoading: Boolean;
  resetPasswordLinkLoading: Boolean;
  resetPasswordLinkVerificationLoading: Boolean;
  resetPasswordLoading: Boolean;
  logoutUserLoading: Boolean;
  generateTwoFactorLoading: Boolean;
  verifyTwoFactorLoading: Boolean;
  user: object | null;
  error: any;
  response: any;
  success: Boolean;
  loggedIn: Boolean;
  previousLocation: string;
}
const initialState: AuthenticationState = {
  loginLoading: false,
  resetPasswordLinkLoading: false,
  resetPasswordLinkVerificationLoading: false,
  resetPasswordLoading: false,
  logoutUserLoading: false,
  generateTwoFactorLoading: false,
  verifyTwoFactorLoading: false,
  user: {},
  loggedIn: false,
  error: null,
  response: null,
  success: false,
  previousLocation: "",
};
export const authenticationSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    logout: (state) => {
      localStorage.clear();
      state.loginLoading = false;
      state.resetPasswordLinkLoading = false;
      state.resetPasswordLinkVerificationLoading = false;
      state.resetPasswordLoading = false;
      state.logoutUserLoading = false;
      state.generateTwoFactorLoading = false;
      state.verifyTwoFactorLoading = false;
      state.user = null;
      state.error = null;
      state.loggedIn = false;
      state.success = false;
      state.previousLocation = "";
    },
    reset: (state) => {
      state.error = null;
      state.success = false;
      state.response = null;
    },
    setPreviousLocation: (state, action) => {
      state.previousLocation = action.payload;
    },
    setLoggedIn: (state, action) => {
      state.loggedIn = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(PURGE, () => { return initialState; });
    builder.addCase(loginUser.pending, (state) => {
      state.loginLoading = true;
      state.loggedIn = false;
      state.error = null;
    });
    builder.addCase(loginUser.fulfilled, (state, action) => {
      state.loginLoading = false;
      state.user = action.payload;
    });
    builder.addCase(loginUser.rejected, (state, action) => {
      state.loginLoading = false;
      state.loggedIn = false;
      state.error = action.payload;
    });

    builder.addCase(resetPasswordLink.pending, (state) => {
      state.resetPasswordLinkLoading = true;
      state.success = false;
      state.error = null;
    });
    builder.addCase(resetPasswordLink.fulfilled, (state, action) => {
      state.resetPasswordLinkLoading = false;
      state.success = true;
      state.response = action.payload;
    });
    builder.addCase(resetPasswordLink.rejected, (state, action) => {
      state.resetPasswordLinkLoading = false;
      state.success = false;
    });

    builder.addCase(resetPasswordLinkVerification.pending, (state) => {
      state.resetPasswordLinkVerificationLoading = true;
      state.success = false;
      state.error = null;
    });
    builder.addCase(
      resetPasswordLinkVerification.fulfilled,
      (state, action) => {
        state.resetPasswordLinkVerificationLoading = false;
        state.success = true;
        state.response = action.payload;
      }
    );
    builder.addCase(resetPasswordLinkVerification.rejected, (state, action) => {
      state.resetPasswordLinkVerificationLoading = false;
      state.success = false;
    });

    builder.addCase(resetPassword.pending, (state) => {
      state.resetPasswordLoading = true;
      state.success = false;
      state.error = null;
    });
    builder.addCase(resetPassword.fulfilled, (state, action) => {
      state.resetPasswordLoading = false;
      state.success = true;
      state.response = action.payload;
    });
    builder.addCase(resetPassword.rejected, (state, action) => {
      state.resetPasswordLoading = false;
      state.success = false;
    });

    builder.addCase(logoutUser.pending, (state) => {
      state.logoutUserLoading = true;
      state.loggedIn = false;
      state.error = null;
    });
    builder.addCase(logoutUser.fulfilled, (state, action) => {
      state.logoutUserLoading = false;
      state.loggedIn = false;
      state.user = null;
    });
    builder.addCase(logoutUser.rejected, (state, action) => {
      state.logoutUserLoading = false;
      state.loggedIn = false;
      state.error = action.payload;
    });

    builder.addCase(generateTwoFactor.pending, (state) => {
      state.generateTwoFactorLoading = true;
      state.success = false;
      state.error = null;
    });
    builder.addCase(generateTwoFactor.fulfilled, (state, action) => {
      state.generateTwoFactorLoading = false;
      state.success = true;
      state.response = action.payload;
    });
    builder.addCase(generateTwoFactor.rejected, (state, action) => {
      state.generateTwoFactorLoading = false;
      state.success = false;
      state.error = action.payload;
    });

    builder.addCase(verifyTwoFactor.pending, (state) => {
      state.verifyTwoFactorLoading = true;
      state.success = false;
      state.error = null;
    });
    builder.addCase(verifyTwoFactor.fulfilled, (state, action) => {
      state.verifyTwoFactorLoading = false;
      state.success = true;
      state.response = action.payload;
    });
    builder.addCase(verifyTwoFactor.rejected, (state, action) => {
      state.verifyTwoFactorLoading = false;
      state.success = false;
      state.error = action.payload;
    });
    // builder.addCase(registerUser.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.payload;
    // });
    // builder.addCase(verifyEmail.pending, (state) => {
    //   state.loading = true;
    //   state.success = false;
    // });
    // builder.addCase(verifyEmail.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.success = true;
    //   state.response = action.payload;
    // });
    // builder.addCase(verifyEmail.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.payload;
    // });
  },
});

export const { logout, reset, setPreviousLocation, setLoggedIn } =
  authenticationSlice.actions;

export const authenticationReducer = authenticationSlice.reducer;
